import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumVesselSummaryField implements BaseEnumType {
  private static allValues: EnumVesselSummaryField[] = []; // make sure this is top-most
  
  public static output = new EnumVesselSummaryField(0, "Output", "enum_vessel_summary_field_output");
  public static recipe = new EnumVesselSummaryField(1, "Recipe", "enum_vessel_summary_field_recipe");
  public static batchNumber = new EnumVesselSummaryField(2, "BatchNumber", "enum_vessel_summary_field_batch_number");
  public static startDate = new EnumVesselSummaryField(3, "StartDate", "enum_vessel_summary_field_start_date");
  public static assemblyName = new EnumVesselSummaryField(4, "AssemblyName", "enum_vessel_summary_field_assembly_name");
  public static expectedEndDate = new EnumVesselSummaryField(5, "ExpectedEndDate", "enum_vessel_summary_field_expected_end_date");
  public static currentOutput = new EnumVesselSummaryField(6, "CurrentOutput", "enum_vessel_summary_field_current_output");
  public static remainingExpectedOutput = new EnumVesselSummaryField(7, "RemainingExpectedOutput", "enum_vessel_summary_field_remaining_expected_output");
  public static assemblyType = new EnumVesselSummaryField(8, "AssemblyType", "enum_vessel_summary_field_assembly_type");
  public static costSoFar = new EnumVesselSummaryField(9, "CostSoFar", "enum_vessel_summary_field_cost_so_far");
  public static expectedCost = new EnumVesselSummaryField(10, "ExpectedCost", "enum_vessel_summary_field_expected_cost");
  public static vesselState = new EnumVesselSummaryField(11, "VesselState", "enum_vessel_summary_field_vessel_state");
  public static produceMaterial = new EnumVesselSummaryField(12, "ProduceMaterial", "enum_vessel_summary_field_produce_material");
  public static processSubBatch = new EnumVesselSummaryField(13, "ProcessSubBatch", "enum_vessel_summary_field_process_sub_batch");
  public static obsolete_BatchName = new EnumVesselSummaryField(14, "Obsolete_BatchName", "enum_vessel_summary_field_obsolete__batch_name");
  public static obsolete_VesselValuation = new EnumVesselSummaryField(15, "Obsolete_VesselValuation", "enum_vessel_summary_field_obsolete__vessel_valuation");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselSummaryField.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isOutput() { return this === EnumVesselSummaryField.output; }
  public isRecipe() { return this === EnumVesselSummaryField.recipe; }
  public isBatchNumber() { return this === EnumVesselSummaryField.batchNumber; }
  public isStartDate() { return this === EnumVesselSummaryField.startDate; }
  public isAssemblyName() { return this === EnumVesselSummaryField.assemblyName; }
  public isExpectedEndDate() { return this === EnumVesselSummaryField.expectedEndDate; }
  public isCurrentOutput() { return this === EnumVesselSummaryField.currentOutput; }
  public isRemainingExpectedOutput() { return this === EnumVesselSummaryField.remainingExpectedOutput; }
  public isAssemblyType() { return this === EnumVesselSummaryField.assemblyType; }
  public isCostSoFar() { return this === EnumVesselSummaryField.costSoFar; }
  public isExpectedCost() { return this === EnumVesselSummaryField.expectedCost; }
  public isVesselState() { return this === EnumVesselSummaryField.vesselState; }
  public isProduceMaterial() { return this === EnumVesselSummaryField.produceMaterial; }
  public isProcessSubBatch() { return this === EnumVesselSummaryField.processSubBatch; }
  public isObsolete_BatchName() { return this === EnumVesselSummaryField.obsolete_BatchName; }
  public isObsolete_VesselValuation() { return this === EnumVesselSummaryField.obsolete_VesselValuation; }

  public static getValues(): readonly EnumVesselSummaryField[] {
    return EnumVesselSummaryField.allValues;
  }

  public static getValuesExcept0(): readonly EnumVesselSummaryField[] {
    return EnumVesselSummaryField.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVesselSummaryField {
    const found = EnumVesselSummaryField.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselSummaryField - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVesselSummaryField): EnumVesselSummaryField {
    const found = name ? EnumVesselSummaryField.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVesselSummaryField - Value not found: ${ name }`);
    }

    return found;
  }
}